/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'indent': {
    width: 8,
    height: 8,
    viewBox: '0 0 8 8',
    data: '<path pid="0" d="M5.57 7.71L7.985.564c.118-.341-.21-.656-.551-.55L.298 2.437a.434.434 0 0 0-.091.774L2.54 4.747 5.833 2.07c.092-.078.184.013.105.105L3.262 5.468 4.81 7.816a.424.424 0 0 0 .76-.105z" _fill="#376F99" fill-rule="nonzero"/>'
  }
})
